'use client'
import { useEffect } from 'react'

export function TokenRefresher() {
  useEffect(() => {
    const refresh = () =>
      fetch('/api/users/refresh-token', { method: 'POST', credentials: 'include' }).catch(() => {})

    refresh()
    const interval = setInterval(refresh, 10 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  return null
}